<div class="auth">
  <div class="form">
    <div class="form-container">
      <div>
        <ng-content></ng-content>
      </div>
    </div>
  </div>

  <div class="sidebar">
    <img
      alt="sky-social-media-post-and-monetization"
      src="assets/shared/images/auth/sky-social-media-post-and-monetization.svg"
      width="214"
      height="186"
    />

    <div class="sidebar-description">
      <h3>Make social media a doddle</h3>
      <p>
        No tricky dashboards, no stress - just effortless posting that actually
        works.
      </p>
    </div>

    <div class="sidebar-image-bottom">
      <img
        alt="sky-user-avatar-and-social-media-reactions"
        src="assets/shared/images/auth/sky-user-avatar-and-social-media-reactions.svg"
        height="160"
        width="160"
      />
    </div>
  </div>
</div>
